import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { I18nModule } from '@p2p/i18n';

import { PayinPayoutSwitchingComponent } from './payin-payout-switching/payin-payout-switching.component';
import { PaymentFeatureSwitchingI18nModule } from './payment-feature-switching.i18n.module';

@NgModule({
    imports: [CommonModule, I18nModule, PaymentFeatureSwitchingI18nModule, MatSlideToggleModule],
    declarations: [PayinPayoutSwitchingComponent],
    exports: [PayinPayoutSwitchingComponent]
})
export class PaymentFeatureSwitchingModule {}
